import { useQuery } from '@tanstack/react-query';

import { Alert, AlertDescription, AlertTitle } from '@nesso/ui/primitives/alert';

import { subscriptionMeOptions } from '@/entities/subscription';
import { PickPlan } from '@/features/subscription/pick-plan';
import { useStartCheckout } from '@/features/subscription/start-checkout';
import { Page } from '@/shared/ui/layout/page';
import { NavigationBar } from '@/shared/ui/navigation/navigation-bar';
import { UserDropdown } from '@/widgets/user/user-dropdown';

function formatDate(iso: string | null): string {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
}

export function TrialExpiredPage() {
    const { data: subscription } = useQuery(subscriptionMeOptions());
    const { selectPlan, pendingPlanCode } = useStartCheckout();

    const expiredDate = subscription?.currentPeriodEnd
        ? formatDate(subscription.currentPeriodEnd)
        : '';
    const deletionDate = subscription?.retentionEndsAt
        ? formatDate(subscription.retentionEndsAt)
        : '';

    return (
        <Page>
            <NavigationBar dropdown={<UserDropdown />} disableLogoNavigation />
            <div className="flex flex-1 flex-col items-center overflow-y-auto px-4">
                <div className="w-full max-w-240 space-y-6 pt-6 xs:pt-10">
                    <Alert variant="warning" className="w-full max-w-192.5">
                        <AlertTitle>Trial expired</AlertTitle>
                        <AlertDescription>
                            Your trial expired
                            {expiredDate ? ` on ${expiredDate}` : ''}. Choose a plan below to
                            continue using Nesso.
                            {deletionDate
                                ? ` If you do not select a plan by ${deletionDate}, your account will be deleted.`
                                : ''}
                        </AlertDescription>
                    </Alert>
                    <PickPlan pendingPlanCode={pendingPlanCode} onSelectPlan={selectPlan} />
                </div>
            </div>
        </Page>
    );
}
